<template>
  <div :class="$style.container">
    <img
      :src="imageUrl"
      alt="Offer accepted illustration"
      :class="$style.image"
    />
    <BaseHeading size="l" mb mt :class="$style.heading">
      {{
        $t(
          'subscription.cancelation_flow.success_treatwell_offer.description_updated'
        )
      }}
    </BaseHeading>
    <BaseText v-if="loading" :class="$style.description">
      {{ $t('generic.loading') }}...
    </BaseText>
    <BaseText v-else :class="$style.description">
      {{
        $t(
          'subscription.cancelation_flow.success_treatwell_offer.description_activation',
          {
            date: filters.date(dayjs(result?.periodEnd), { format: 'long' })
          }
        )
      }}
    </BaseText>
  </div>
</template>

<script setup lang="ts">
import filters from '@/filters';
import dayjs from '@/dayjs';
import { useQuery } from '@vue/apollo-composable';
import { GET_STRIPE_SUBSCRIPTIONS_QUERY } from '../graphql';

const { result, loading } = useQuery(GET_STRIPE_SUBSCRIPTIONS_QUERY);

const imageUrl = '/img/cancel-subscription/treatwell_offer.svg';
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.image {
  margin-bottom: 1.5rem; // mb-6
  height: 10rem; // h-40
  width: auto;
}
</style> 
